import React, { useEffect, useState } from "react";
import { Button } from "../../../components/ui/button";
// import { Document, Page, pdfjs } from "react-pdf";
import { Loader2, FileWarning } from "lucide-react";
import { Worker, Viewer } from '@react-pdf-viewer/core';
// @ts-ignore
import '@react-pdf-viewer/core/lib/styles/index.css';
// @ts-ignore
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

interface DocumentViewerProps {
    files: string[];
}

export default function DocumentViewer({ files }: DocumentViewerProps) {
    const validFiles = files ?? [];
    const [selected, setSelected] = useState<any>(validFiles[0] || "");
    const [numPages, setNumPages] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    // when file changes, trigger loading reset
    useEffect(() => {
        if (selected) {
            setError(null);
            setLoading(true);
            setNumPages(null);
        }
    }, [selected]);

    const handleSelect = (url: string) => {
        setSelected(url);
    };

    const getFileType = (url: string): string => {
        console.log("url : ", url);
        return "";
        // const ext = url?.split(".")?.pop()?.split("?")[0]?.toLowerCase();
        // switch (ext) {
        //     case "pdf":
        //         return "pdf";
        //     case "jpg":
        //     case "jpeg":
        //     case "png":
        //     case "gif":
        //     case "webp":
        //         return "image";
        //     default:
        //         return "unsupported";
        // }
    };

    const fileType = getFileType(selected?.url);

    useEffect(() => {
        if (fileType === "unsupported") {
            setLoading(false);
        }
    }, [fileType]);

    const renderFile = () => {
        switch (fileType) {
            case "pdf":
                return (
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <div
                            style={{ width: "100%", height: "600px" }}
                            className="rounded-lg border overflow-hidden"
                        >
                            <Viewer
                                fileUrl={selected}
                                onDocumentLoad={() => setLoading(false)}
                            />
                        </div>
                    </Worker>
                );

            case "image":
                return (
                    <img
                        src={selected}
                        alt="Document Preview"
                        className="max-w-full max-h-[80vh] rounded-lg object-contain shadow-md"
                        onLoad={() => setLoading(false)}
                        onError={() => {
                            setError("Failed to load image");
                            setLoading(false);
                        }}
                    />
                );

            default:
                // setLoading(false);
                return (
                    <div className="text-gray-500 text-center">
                        <FileWarning className="w-8 h-8 mb-2 mx-auto" />
                        Unsupported file type.
                    </div>
                );
        }
    };

    return (
        <div>
            <div className="flex  justify-center  gap-2 overflow-x-auto mt-3 pb-2 border-b">
                {validFiles.length === 0 && (
                    <div className="text-gray-500 text-center">
                        <FileWarning className="w-8 h-8 mb-2 mx-auto" />
                        No files to view
                    </div>
                )}

                <div className="flex gap-2 overflow-x-auto mt-3 pb-2 border-b">
                    {validFiles.length > 0 &&
                        validFiles.map((url, index) => {
                            const name = `File ${index + 1}`;
                            const type = getFileType(url);

                            return (
                                <button
                                    key={url}
                                    onClick={() => handleSelect(url)}
                                    className={`flex items-center gap-2 px-3 py-1 rounded-full border transition-all whitespace-nowrap
                                        ${selected === url
                                            ? "bg-primary text-white border-primary shadow-md"
                                            : "bg-muted text-muted-foreground border-gray-300 hover:bg-gray-100"
                                        }`}
                                >
                                    <span className="text-sm font-medium">{name}</span>
                                </button>
                            );
                        })}
                </div>

            </div>

            {/* viewer */}
            {validFiles.length !== 0 && (
                <div className="flex-1 mt-4 flex items-center justify-center bg-muted rounded-lg p-3 relative min-h-[300px]">
                    {loading && (
                        <div className="flex items-center gap-2 text-gray-500 absolute">
                            {fileType !== 'pdf' && (
                                <>
                                    <Loader2 className="animate-spin w-5 h-5" />
                                    Loading...
                                </>
                            )}
                        </div>
                    )}

                    {error && (
                        <div className="flex flex-col items-center text-red-500">
                            <FileWarning className="w-8 h-8 mb-2" />
                            <p>{error}</p>
                        </div>
                    )}

                    {!error && renderFile()}
                </div>
            )}
        </div>
    );
}
